<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "OutstandingMemberIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
